import { Injectable } from '@angular/core';
import { BaseApi } from '../../laas/base-api.service';
import { AdminAuthService } from '../../admin/admin-auth.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ViewReportService {
  
  adminId: string;
  baseUrl: string;
  private applicantId: string;
  public isRetail: boolean;

  constructor(
    private api: BaseApi,
  ) {
    this.applicantId = this.getApplicantID();
    this.adminId = sessionStorage.getItem('wl-admin-id');
    this.baseUrl = `/applicants/${this.applicantId}`;

  }

  getApplicantID() {
    return sessionStorage.getItem('wl-applicant-id');
  }

  getUsersSearch(input, roleId,offset,limit,page) {
    
    let dataObj = {
      "adminId": this.adminId,
      "roleId":  this.getRoleId(),
      "filter": input,
      "offset": offset,
      "limit": limit,
      "data_type":"Online",
      "branch_code":sessionStorage.getItem('branch_code'),
    "ro_code":sessionStorage.getItem('ro_code'),
    "zonal_code":sessionStorage.getItem('zonal_code')
    }
    let filterDate = sessionStorage.getItem('filterDateViewOnline')?sessionStorage.getItem('filterDateViewOnline'):'';   
    if(filterDate){
          let date = new Date(filterDate);
          let dateInMs = date.getTime();
           dataObj['filter_date']=dateInMs;
        }
    
    return this.api.newPost(`/users/userSearch`,dataObj, true).pipe(map(res => {
      if (!res.result) {
        return '';
      }
      let i = page * 10 - 9;
      if(res && res.result && res.result.resultData){
        res.result.resultData.forEach(user => user.srNo = i++)
        return res;
      }
    }))
  }

  getUsersFilterDate(input, roleId,offset,limit,filterDate) {

    let dataObj = {
      "adminId": this.adminId,
      "roleId": this.getRoleId(),
      "filter": input,
      "offset": offset,
      "limit": limit,
      "data_type":"Online",
      "filter_date":filterDate,
      "branch_code":sessionStorage.getItem('branch_code'),
    "ro_code":sessionStorage.getItem('ro_code'),
    "zonal_code":sessionStorage.getItem('zonal_code')
    }
    let filterDate1 = sessionStorage.getItem('filterDateViewOnline')?sessionStorage.getItem('filterDateViewOnline'):'';   
    if(filterDate1){
          let date = new Date(filterDate1);
          let dateInMs = date.getTime();
           dataObj['filter_date']=dateInMs;
        }
    
    return this.api.postRes('/users/userSearch', dataObj).pipe(map(resp => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }



  getUsers(input, roleId,offset,limit) {

    let dataObj = {
      "adminId": this.adminId,
      "roleId": this.getRoleId(),
      "filter": input,
      "offset": offset,
      "limit": limit,
      "data_type":"Online",
      "branch_code":sessionStorage.getItem('branch_code'),
    "ro_code":sessionStorage.getItem('ro_code'),
    "zonal_code":sessionStorage.getItem('zonal_code')
    }
    let filterDate = sessionStorage.getItem('filterDateViewOnline')?sessionStorage.getItem('filterDateViewOnline'):'';   
    if(filterDate){
          let date = new Date(filterDate);
          let dateInMs = date.getTime();
           dataObj['filter_date']=dateInMs;
        }
    
    return this.api.postRes('/users/userSearch', dataObj).pipe(map(resp => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      return resp;
    }))

    // return this.api.newPost(`/users/search-users/${page}`, { input: input ? input : '' }, true).map(res => {
    //   if (!res.result) {
    //     return '';
    //   }
    //   let i = page * 10 - 9;
    //   res.result.forEach(user => user.srNo = i++)
    //   return res;
    // })
  }

  generateInvoice(custName,custId,custMail,isRetail){
    let dataObj = {
      "adminId": this.adminId,
      "custName": custName,
      "custId": custId,
      "email": custMail,
      "isRetail": isRetail,
    }      
   
    

    return this.api.postRes('/users/generateBill', dataObj).pipe(map(resp => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }

  getRocCounts() {
    return this.api.newGet(`/pdf/getCount/roc`).pipe(map(res => {
      return res;
    }))
  }
  getfreshcasesreport(start_date, end_date){
    return this.api.postRes('/pdf/getfreshcasesreport', {start_date, 
      end_date, 
      zonal_code:sessionStorage.getItem('zonal_code'),
      ro_code:sessionStorage.getItem('ro_code'), 
      branch_code:sessionStorage.getItem('branch_code') }).pipe(map(resp => {

      return resp;
    }))
  }

  generateLogReport() {
    return this.api.newGet(`/pdf/getLogDataForAdmin/${this.adminId}`).pipe(map(report => {
      console.log(report);
      return report;
    }))
  }

  getCoApplicants(custId) {
    return this.api.postRes('/users/getCoApplicants', { custId: custId }).pipe(map(resp => {
      console.log("resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }

  getGuarantors(custId) {
    return this.api.postRes('/users/getguarantors', { custId: custId }).pipe(map(resp => {
      console.log("resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }
  getRoleId(){
   return sessionStorage.getItem('getroleId');
  }

}
